'use client';
import { jsx } from 'react/jsx-runtime';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var o, r, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(r = 0; r < i.length; r++)o = i[r], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var o, r, n = {}, i = Object.keys(e);
    for(r = 0; r < i.length; r++)o = i[r], t.indexOf(o) >= 0 || (n[o] = e[o]);
    return n;
}
let n = renderWithRef('ThumbnailsHeroContentContainer', null, (t, r)=>{
    var { children: n } = t;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        classNames: [
            'swan-thumbnails-hero-content-container'
        ],
        props: _object_without_properties(t, [
            "children"
        ]),
        children: n
    });
});
const ThumbnailsHeroContentContainer = deprecatedComponent({
    description: 'Remove any content and use only an image',
    displayName: 'ThumbnailsHeroContentContainer',
    root: n
});

export { ThumbnailsHeroContentContainer };
